import React from 'react'
import Link from 'gatsby-link'
import Flagicon from '../components/flagicon'
import { Table } from "reactstrap";

import { findCountry, findCountryUpper } from "../components/helpers/countries";

var worldjson = require('../../node_modules/world-countries/dist/countries.json');

const GroupF = (props) =>{
  const groups = props.data.allThirdPartyWorldCupGroups.edges;

  function searchCountryName(code) {
    if (code == ('gb' || 'GB')) {
      return 'England';
    }
    for (var i = 0; i < worldjson.length; i++) {
      if (worldjson[i].cca2 == code) {
          return worldjson[i].translations.deu.common;
      }
      
  }
  }

  return (
  <div>
    <h1>Gruppen</h1>
    {groups.map((group,i) => {
      const groupData = group;
      console.log(groupData)
      return (
        <div>
        <h2>Gruppe {groupData.node.letter}</h2>
    
<Table striped>
  <tr>
    <th>#</th>
    <th>Land</th>
    <th>Pkt.</th>
    <th>TDiff.</th>
  </tr>
  {groupData.node.ordered_teams.map((teams,i) => {
    return (
      <tr>
      <td>{i+1}</td>
      <td><Flagicon code={findCountry(teams.fifa_code)} /> {searchCountryName(findCountryUpper(teams.fifa_code))}</td>
      <td>{teams.points}</td>
      <td>{teams.goal_differential}</td>
    </tr>
    )

  })}
</Table>
</div>
      )
    })}


  </div>
  )

} 

export default GroupF

export const query = graphql`
query MyGroupQuery {
  allThirdPartyWorldCupGroups {
    edges {
      node {
        letter
        ordered_teams {
          fifa_code
          points
          goal_differential
        }
      }
    }
  }
}
`;  



// WEBPACK FOOTER //
// ./src/pages/groups.js